import './FilePlaceholder.less';
import React, {useState, useEffect} from 'react';


export default function FilePlaceholder(
    {
        title,
        mimeType,
    }
) {

    return <div className="file-placeholder">
        <div className="title">{title}</div>
    </div>;
}
